import { isEmpty } from '../../../general/isEmpty';

// ----------------------------------------------------------------------------

function normalizeValues(element: HTMLSelectElement, value: string | string[]): string[] {
    if (isEmpty(value)) {
        return [];
    }

    if (Array.isArray(value)) {
        return value.map(String);
    }

    const currentValue = value;

    if (!element.multiple || !currentValue.includes(',')) {
        return [currentValue];
    }

    const hasExactOptionValue = Array.from(element.options).some((elOption): any => elOption.value === currentValue);

    if (hasExactOptionValue) {
        return [currentValue];
    }

    return currentValue
        .split(',')
        .map((item): any => item.trim())
        .filter(Boolean);
}

// ----------------------------------------------------------------------------

export default normalizeValues;
